import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'

import Image from '../../shared/assets/images/errorImage.svg'

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: '2rem',
    maxWidth: '35rem',
    width: '100%',
    textAlign: 'center',
  },
}

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.container}>
        <Box component={'img'} sx={{ width: '100%', mb: '2rem' }} src={Image} />
        <Typography color='primary' sx={{ mt: '2rem', fontSize: '1.75rem' }}>
          PAGE NOT FOUND!
        </Typography>
        <Typography sx={{ fontSize: '1rem' }}>
          This page doesn&apos;t exist or was removed.
        </Typography>
        <Typography sx={{ fontSize: '1rem' }}>Click the button below to go Back.</Typography>
        <Button
          sx={{ p: 2, mt: '2rem', borderRadius: '2rem' }}
          fullWidth
          variant='contained'
          disableElevation
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>
    </Box>
  )
}

export default NotFound
